module.exports = __webpack_public_path__ + "img/banner-6.b327302a.jpg";